'use strict';

import React, { useEffect, useRef } from 'react';

export const Tick = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
);

export const ErrorIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M12 8v5M12 16h.01" /></svg>
);

export const CHIPS = ['Päätös jopa samana päivänä', 'Maksuton & sitoumukseton', 'Henkilökohtainen palvelu'];

export function TrustChips({ items }) {
  return (
    <div className="kr-trust-chips" role="list">
      {items.map((text) => (
        <span className="kr-chip" role="listitem" key={text}><span className="kr-tick"><Tick /></span>{text}</span>
      ))}
    </div>
  );
}


/**
 * Trustpilot review carousel — the same widget configuration kasvurahoitus.fi uses
 * (template 53aa8912dec7e10d38f59f36, Finnish reviews, 140px). The bootstrap script is
 * loaded on demand so the page does not depend on GTM for it.
 */
const TP_SCRIPT = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

export function TrustpilotCarousel() {
  const ref = useRef(null);

  useEffect(() => {
    const render = () => { if (window.Trustpilot && ref.current) window.Trustpilot.loadFromElement(ref.current, true); };
    if (window.Trustpilot) { render(); return undefined; }
    let script = document.querySelector(`script[src="${TP_SCRIPT}"]`);
    if (!script) {
      script = document.createElement('script');
      script.src = TP_SCRIPT;
      script.async = true;
      document.head.appendChild(script);
    }
    script.addEventListener('load', render);
    return () => script.removeEventListener('load', render);
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="fi-FI"
      data-template-id="53aa8912dec7e10d38f59f36"
      data-businessunit-id="607582d37881d800016abf4e"
      data-style-height="140px"
      data-style-width="100%"
      data-theme="light"
      data-stars="1,2,3,4,5"
      data-review-languages="fi"
    >
      <a href="https://fi.trustpilot.com/review/kasvurahoitus.fi" target="_blank" rel="noopener noreferrer">Trustpilot</a>
    </div>
  );
}
